/**
 * ArticleBody — THE way the web draws an article's stored text (its HTML, as
 * the editor wrote it): sanitized, in the reader's prose container.
 *
 * The article reader (routes/library/article.$articleId.tsx) draws the
 * article's current text with it, and the History panel
 * (components/kb/ArticleHistoryPanel.tsx) draws a saved version with it — so
 * a version reads exactly as the reader would show it once restored (numbered
 * lists, task items, tables, code blocks and all). Before review LB6-T9-REV-01
 * the History view ran the HTML through the lossy HTML-to-Markdown export
 * helper first, and showed text that differed from what Restore writes back.
 */
import { sanitizeHtml } from '@/lib/sanitize';

export function ArticleBody({ html, emptyText = 'No content yet.' }: { html: string; emptyText?: string }) {
  const safe = sanitizeHtml(html);
  if (!safe) {
    return (
      <div className="prose prose-sm max-w-none dark:prose-invert">
        <p className="text-muted-foreground">{emptyText}</p>
      </div>
    );
  }
  return <div className="prose prose-sm max-w-none dark:prose-invert" dangerouslySetInnerHTML={{ __html: safe }} />;
}
